import { Component, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModalConfig, NgbOffcanvas, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { BulletinService } from '../../../../../core/services/bulletin.service';
import { ClassroomService } from '../../../../../core/services/classroom.service';
import { CompositionService } from '../../../../../core/services/composition.service';
import { FileService } from '../../../../../core/services/file.service';
import { NoteService } from '../../../../../core/services/note.service';
import { PeriodService } from '../../../../../core/services/period.service';
import { ProfessorAcademicClassroomService } from '../../../../../core/services/professor-academic-classroom.service';
import { StudentAyClassroomService } from '../../../../../core/services/student-ay-classroom.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import {FileService as myFileService} from '../../../../../core/utils/file-service'
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';

@Component({
    selector: 'app-bulletin',
    templateUrl: './bulletin.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule],
    styleUrls: ['./bulletin.component.css']
})
export class BulletinComponent {

  buttonsPermission :any|undefined;
 search_text=""
  classrooms:any[] =[]
  students:any[] =[]
  roles:any[] =[]
  data:any[] =[]
  notes:any[] =[]
  periods:any[] =[]
  compositions:any[] =[]
  courses:any[] =[]
  pacs:any[] =[]
  selected_data:any;
  modalOption:any; 
  pacId:any; 
  periodId:any; 
  currentCompositon:any; 
  isDtInitialized:boolean = false
  is_published=null
  loading=false
  tag="admin-note-book"
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  role:any
  user:any
  currentDetails:any

  pdfViewLoader=false
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined
  canPublish=false

  constructor(
    private spinnerService:NgxSpinnerService,
    private router:Router,
    private noteService:NoteService,
    private fileService:FileService,
    private compService:CompositionService,
    private bulletinService:BulletinService,
    private periodService:PeriodService,
    private sacService:StudentAyClassroomService,
    private classroomService:ClassroomService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
      private offcanvasService: NgbOffcanvas,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.init()
    this.getActions()
  }

  init(){
       
    this.user=this.lsService.get(GlobalName.userName)
      this.role=this.user.roles[0].name.toLowerCase()
    this.getPeriods()
    this.getClassrooms()
    this.currentCompositon=undefined
  }

  getPeriods(){
    this.periodService.getByState(1).subscribe((res:any)=>{
      this.periods=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des notes",err)
    })
  }

  setPacId(event:any){
    this.pacId=event.target.value
    //this.courses=this.pacs.find((el:any)=>el.id==event.target.value).courses
  }

  getFile(code:any,folder:any,filename:any,css='details-panel'){
    this.spinnerService.show()
    this.pdfViewLoader=true
    this.fileService.get({
      folder:folder,
      code:code,
      filename:filename
    }).subscribe((res:any)=>{
      this.spinnerService.hide()
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: css, position: 'end'  });

    },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Gestion des notes",err)

    })
  }
  getFile2(path:any,css='details-panel'){
    this.spinnerService.show()
    this.pdfViewLoader=true
    this.fileService.get({
      path:path
    }).subscribe((res:any)=>{
      this.spinnerService.hide()
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: css, position: 'end'  });

    },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Gestion des notes",err)

    })
  }

  open(i:any){
    this.pdfSrc=this.data[i].motif_file
    this.offcanvasService.open(this.contentPDF,{  panelClass: 'details-panel', position: 'end'  });

  }
 
  getClassrooms(){
    this.classroomService.getByState(1).subscribe((res:any)=>{
      this.classrooms=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des notes",err)
    })
  }
  loadCompositions1(event:any){
    this.pacId=event.target.value
    if (this.pacId != undefined && this.periodId!=undefined) {
      // this.compService.getBulletin(this.pacId,this.periodId).subscribe((res:any)=>{
      //   this.data=res.data
      //   let filtered=this.data.filter((el:any) => el.bulletin.is_confirmed==false &&  el.bulletin.is_published==false )
      //   if(filtered.length==0)this.canPublish=true
      // },
      // (err:any)=>{
      //   AppErrorShow.showError("Gestion des notes",err)

      // })

      this.getData()
    } 
    this.sacService.getAll(this.pacId).subscribe((res:any)=>{
      this.students=res.data
   
    },
    (err:any)=>{
      AppErrorShow.showError("Gestion des notes",err)

    })
   
  }
  loadCompositions2(event:any){
    this.periodId=event.target.value

    if (this.pacId != undefined && this.periodId!=undefined) {
      this.getData()
    } 
   
  }
  getData(){
    this.spinnerService.show()
    this.compService.getBulletin(this.pacId,this.periodId).subscribe((res:any)=>{
      this.data=res.data
      let filtered=this.data.filter((el:any) => el.bulletin?.is_confirmed==false &&  el.bulletin?.is_published==false )
      if(filtered.length==0)this.canPublish=true
      this.spinnerService.hide()

    },
    (err:any)=>{
      this.spinnerService.hide()

      AppErrorShow.showError("Gestion des notes",err)

    })
  }

  reload(){
    this.compService.getBulletin(this.pacId,this.periodId).subscribe((res:any)=>{
      this.currentDetails=null
      this.data=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des notes",err)
    })
  }
  loadNotes(event:any){
      this.currentCompositon=this.compositions.find((el:any)=>el.id==event.target.value)
      this.noteService.getByComposition(event.target.value).subscribe((res:any)=>{
        this.data=res.data
      },
      (err:any)=>{
        AppErrorShow.showError("Gestion des notes",err)

      })
  }


  resetNote(event:any, i:any){
      if(event.target.value=="0")this.data[i].value=0
      this.data[i].isSetted=event.target.value=="0"?0:1
  }


  async upload(ev:any, i:any){
    if (ev.target.files.length!=0) {
      this.data[i].motif_file=await myFileService.fromArrayBufferToBase64(await myFileService.readFileAsync(ev.target.files[0]))
      this.data[i].hasFile=true
    }
  }


  remove(i:any){
    this.data[i].motif_file=""
    this.data[i].hasFile=false  
  }


  store(value:any){
    this.loading=true
    console.log(this.data)
    this.noteService.store({
      composition_id:value.composition_id,
      notes:this.data
    }).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.modalService.dismissAll()
        

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des notes",err)

    })
  }
  update(value:any){
    this.loading=true

    this.sacService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des notes",err)

    })
  }
  setValidate(id:any){
    //if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Validation','Voulez vous vraiment valider cet bulletin?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
        this.loading=true
    this.bulletinService.setState(id,1).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.reload()
        this.loading=false

    },
    (err:any)=>{
      console.log(err)
      this.loading=false

        AppErrorShow.showError("Gestion des notes",err)

    })
  }
})
  }
  setConfirmed(id:any){
    //if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Bulletin','Voulez vous vraiment confirmer ce résultat semestriel?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
        this.loading=true

    this.bulletinService.confirm(id,1).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.reload()
        this.loading=false

    },
    (err:any)=>{
      console.log(err)
      this.loading=false

        AppErrorShow.showError("Gestion des notes",err)

    })
  }
})
  }
  publish(){
    let confirmed=AppSweetAlert.confirmBox('success','Bulletin','Voulez vous vraiment publier ces résultats ?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
        let ids:any[]=[]
        this.data.forEach((el:any)=>{
          if (el.bulletin!=null) {
            ids.push(el.bulletin.id)
          }
        })
    this.bulletinService.publish(ids).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.router.navigate(['/admin/dashboard'])
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des notes",err)

    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_published=el.is_published
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.compService.validate(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
      },
      (err:any)=>{
        console.log(err)
          AppErrorShow.showError("Gestion des notes",err)

      })
  }

  getActions(){
    // this.buttonsPermission = {
    //   show:AppActionCheck.check(this.tag,'Consultation'),
    //   add:AppActionCheck.check(this.tag,'ajout'),
    //   edit:AppActionCheck.check(this.tag,'edition'),
    //   delete:AppActionCheck.check(this.tag,'suppression'),
    //   status:AppActionCheck.check(this.tag,'statut')
    // };
    this.buttonsPermission={
      show:false,
      add:true,
      edit:true,
      delete:true,
      status:true,
    }
  }

  getState(compositions:any){
    let sent=compositions.length
    let published = compositions.filter((el:any) => el.is_published==true).length;

    return `${published}/${sent}`; 
  }


  generateBulletin(){
    if (this.pacId != undefined && this.periodId!=undefined) {
      this.compService.generateBulletin(this.pacId,this.periodId).subscribe((res:any)=>{
     // this.getFile2(res.data.path)
      },
      (err:any)=>{
        AppErrorShow.showError("Gestion des notes",err)

      })
    } 
  }
}
